import { Box } from '@factorialco/deprecated-design-system'

import Sidepanel from 'modules/core/components/Sidepanel'
import { useEffect } from 'modules/core/hooks/useEffect'
import i18n from 'modules/core/lib/i18n'

import { useHapiElementsContext } from 'modules/ats/components/HapiElementsLoader'

interface Props {
  onClose: () => void
}

export const ImportContractSidepanel = ({ onClose }: Props) => {
  const { elementsLoaded } = useHapiElementsContext()

  useEffect(() => {
    if (!elementsLoaded) {
      return
    }

    window.hapi.contract.service?.createContract.onSuccess(() => {
      onClose()
    })

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [elementsLoaded])

  return (
    <Sidepanel
      title={i18n.t('ats.vonq.import_contract_sidepanel.title')}
      onClose={onClose}
      width="extended"
      boxPadding={false}
      closeLabel={i18n.t('common.close')}
      open
    >
      <Box height="full">
        {/* @ts-expect-error We're importing a webcomponet without types */}
        <he-contract-add></he-contract-add>
      </Box>
    </Sidepanel>
  )
}
